// extracted by mini-css-extract-plugin
module.exports = {"banner-wrapper":"dd31006766--banner-wrapper--U0XwX"};